import './accountPopups.css';

import 'jquery.cookie';

import AccountBar from './accountBar/AccountBar';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import requestService from "@/js/common/Domain/Service/request";
import accountModel from './accountModel';

var Controller = Backbone.View.extend({
	initModel: function () {
		this.model = accountModel;
	},
	getProfileData: function () {
		var self = this,
			options = {
				url: window.appConfig.accountUrl + '/api/customer/profile',
				type: "get",
				xhrFields: {withCredentials: true}
			};

		this.model.set('profileRequestInProgress', true);

		requestService(options, {
			success: function (response) {
				var data = response.data;
				if (response.success && data) {
					self.model.set('authorized', true);
					self.model.set('email', response.data.email);
					self.model.set('name', response.data.name);
					self.model.set('customerUuid', response.data.uuid);

					trackingService.setCustomerUuid(self.model.get('customerUuid'));
				}
				self.model.set('profileRequestInProgress', false);
				self.model.trigger('profileDataReceived');
				self.model.set('profileDataReceived', 1);
			},
			error: function (response, textStatus) {
				self.model.set('profileRequestInProgress', false);
				self.model.trigger('profileDataReceived');
				self.model.set('profileDataReceived', 1);
			}
		});
	},
	initComponents: function () {
		this.accountBar = new AccountBar({
			el: '#accountBar',
			model: this.model,
			parent: this
		});
	},
	lazyAuthorizeInit: async function () {
		let {default: AccountAuthorize} = await import(/* webpackChunkName: "AccountDialogs" */ "./authorize/Authorize");

		if (!this.authorize) {
			this.authorize = new AccountAuthorize({
				model: this.model,
				parent: this
			});
		}
	},
	lazyRegistrationInit: async function () {
		let {default: AccountRegistration} = await import(/* webpackChunkName: "AccountDialogs" */ "./registration/Registration");

		if (!this.registration) {
			this.registration = new AccountRegistration({
				model: this.model,
				parent: this
			});
		}
	},
	lazyForgotPasswordInit: async function () {
		let {default: AccountForgotPassword} = await import(/* webpackChunkName: "AccountDialogs" */ "./forgotPassword/ForgotPassword");

		if (!this.forgotPassword) {
			this.forgotPassword = new AccountForgotPassword({
				model: this.model
			});
		}
	},
	initialize: function (options) {
		var self = this;
		this.initModel();
		this.getProfileData();

		$(function () {
			self.initComponents();
		});
	}
});

let account = new Controller({
	el: 'body'
});

export default account;

